"use client";
import React, { useState, useEffect ,useContext  } from "react";
import { createPortal } from "react-dom";
import api from "../api";
import "./QuoteBar.css";
import { QuoteContext } from "./QuoteContext";
const QuoteBar = ({ isOpen, onClose }) => {
  const [cart, setCart] = useState([]);
  const { quoteItems, updateQuoteItems } = useContext(QuoteContext);
  // ✅ Load quote cart when opened
  useEffect(() => {
    if (isOpen) {
      loadQuoteCart();
    }
  }, [isOpen]);

  const loadQuoteCart = async () => {
    try {  
      console.log("quoteItems", quoteItems);
        setCart(quoteItems || []);
        
    } catch (err) {
      console.error("Error loading quote cart:", err);
    }
  };

  // ✅ Remove item from cart
  const removeItem = async (item) => {
   
    try {
      const res = await api.post(`/api/quotes/remove-item/`, {
        cart_key: item.cart_key,
      });
      
         const updatedItems = res.data.cartItems || [];
      setCart(updatedItems);
      updateQuoteItems(updatedItems); 
      
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  // ✅ Handle size selection toggle
  const toggleSize = (cartKey, sizeName) => {
    setCart((prevCart) =>
      prevCart.map((item) => {
        const key = `${item.product_id}_${item.color}_${item.size || ""}`;
        if (key !== cartKey) return item;

        let updatedSizes = item.selected_sizes || [];
        if (updatedSizes.includes(sizeName)) {
          updatedSizes = updatedSizes.filter((s) => s !== sizeName);
        } else {
          updatedSizes = [...updatedSizes, sizeName];
        }

        return { ...item, selected_sizes: updatedSizes };
      })
    );
  };

  // ✅ Save selected sizes and redirect
  const saveSizes = async () => {
    const selectedSizes = {};

    cart.forEach((item) => {
      const cartKey = `${item.product_id}_${item.color}_${item.size || ""}`;
      if (item.selected_sizes && item.selected_sizes.length > 0) {
        selectedSizes[cartKey] = item.selected_sizes;
      }
    });

    try {
      const res = await api.post("/api/quotes/save-sizes", {
        sizes: selectedSizes,
      });
      if (res.data?.status === "success") {
        window.location.href = "/quote-request"; // 👈 Change this if you want
      }
    } catch (err) {
      console.error("Error saving sizes:", err);
    }
  };

  return createPortal(
      <>
        {/* Overlay */}
        <div className="cart-overlay" onClick={onClose}></div>
  
        {/* Drawer */}
    <div className={`cart-quote-bar ${isOpen ? "show" : ""}`}>
      {/* Header */}
      <div className="cart-header">
        <h3 className="cart-heading">
          MY QUOTE CART ({cart.length} ITEM{cart.length !== 1 ? "S" : ""})
        </h3>
        <button className="close-quote-cart" onClick={onClose}>
          <i className="fa-regular fa-circle-xmark"></i>
        </button>
      </div>

      {/* Scrollable Product Area */}
      <div className="product-area">
        {cart.length === 0 ? (
          <p className="empty-text">Your quote cart is empty.</p>
        ) : (
          cart.map((item, index) => {
            const cartKey = `${item.product_id}_${item.color}_${item.size || ""}`;
            return (
              <div className="product-item" key={cartKey || index}>
                <div className="product-detail">
                  <img
                    src={item.product?.colorFrontImage || "/no-image.png"}
                    className="product-thumb"
                    alt={item.product?.details?.Title || "Product"}
                  />
                  <div className="item-wrapper">
                    <span className="product-name">
                      {item.product?.details?.Title || "Untitled Product"}
                    </span>
                    <div className="item-wrapper">
                      <span className="product-variation">
                        <span className="brand">{item.brand} </span>
                        <span className="size">{item.style}</span>
                      </span>
                    </div>
                    <div className="item-wrapper">
                      <span className="product-variation">
                        <span className="color">{item.color} </span>
                        <span className="size">${item.product?.salePrice}</span>
                      </span>
                    </div>

                    {/* Sizes */}
                    <div className="item-wrapper">
                      <label className="form-label">Sizes:</label>
                      <div className="size-checkboxes">
                        {(item.sizes || []).map((sizeObj, idx) => {
                          const size = sizeObj.front_size || sizeObj.sizeName;
                          return (
                            <label
                              style={{ display: "inline-block", marginRight: "10px" }}
                              key={size || idx}
                            >
                              <input
                                type="checkbox"
                                className="size-checkbox"
                                data-cart-key={cartKey}
                                value={size}
                                checked={item.selected_sizes?.includes(size) || false}
                                onChange={() => toggleSize(cartKey, size)}
                              />
                              &nbsp;{size}
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cart-edit">
                  <div className="item-wrapper d-flex mr--5 align-items-center">
                    <button
                      className="quote-cart-delete-btn"
                      onClick={() => removeItem(item)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Footer */}
      {cart.length > 0 && (
        <div className="cart-bottom-area">
          <button className="view-btn cart-btn" onClick={saveSizes}>
            Enter Quote Details & Quantities
          </button>
        </div>
      )}
    </div>
   </>,
    document.body
  );
}
export default QuoteBar;
